module.exports = __webpack_public_path__ + "img/event_del.bbdd4962.png";